import React from "react";
import "./itemsummary.scss";
import { IProps } from "./itemsummaryinterface";
import { useTranslation } from "react-i18next";
import helperfunctions from "../../../../utils/helperfunctions";

const ShoppingCartPromo = (props: IProps) => {
    const { t } = useTranslation();

    const getContent = (item: any) => {

     return(<tr className="itemsummaryview">
            <td className="summaryName">{item?.partNumber}</td>
            <td className="summaryRateView">
                <div className="float-right summaryRate">
                    <span className="summaryRate">{ }</span>
                    { }
                </div>
            </td>
            <td className={`summaryRateView `}>
                <div
                    className={`float-right summaryRate`}
                >
                    <span className="summaryRate">{helperfunctions.getUnitPrice(item?.unitPrice, t, item?.isContactDealer)}</span>
                    
                </div>
            </td>
        </tr>)
    }

    return (
        <div>
            <div className="itemSumarryscroll">
                <table className="itemsummary_table">
                    {props?.itemSummaryDetails?.data?.partsSummaryList?.length ? props?.itemSummaryDetails?.data?.partsSummaryList.map((item: any) => (
                        getContent(item)
                    )) : null}
                </table>
            </div>
        </div>

    );
};

export default ShoppingCartPromo;
